import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const PerferredAbhaOptions = ({
  setAdharNumber,
  setSendOtpFunction,
  setPatient1,
  setCurrentStep,
}) => {
  const dispatch = useDispatch();
  const [preferredAbhaAddress, setPreferredAbhaAddress] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");

  useEffect(() => {
    const storedAbhaAddress = localStorage.getItem("preferredAbhaAddress");
    const storedAbhaNumber = localStorage.getItem("preferredAbhaNumber");
    if (storedAbhaAddress) {
      setPreferredAbhaAddress(storedAbhaAddress);
    } else {
      setCurrentStep("AbhaSuggestions");
    }
    if (storedAbhaNumber) setAbhaNumber(storedAbhaNumber);
  }, []);

  const handleContinue = () => {
    setCurrentStep("AbhaCard");
    localStorage.setItem("existingAbha", "true");
  };

  const handleCreateNew = () => {
    setCurrentStep("AbhaSuggestions");
  };

  const masked = abhaNumber.replace(
    /^(\d{2})-(?:\d{4})-(?:\d{4})-(\d{4})$/,
    "$1-xxxx-xxxx-$2"
  );

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Preferred ABHA Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">

                  <p style={{ textAlign: "center", color: "#444", fontSize: "0.9rem", marginBottom: "16px" }}>
                    We found that you already have Preferred ABHA address
                    associated with <br />
                    ABHA Number <strong>{masked}</strong>
                  </p>

                  <input
                    type="text"
                    className="lmop-mobile-input text-center"
                    value={preferredAbhaAddress}
                    readOnly
                    autoComplete="off"
                    style={{ textAlign: "center" }}
                  />

                  <button
                    type="button"
                    className="lmop-continue-btn"
                    onClick={handleContinue}
                  >
                    Continue
                  </button>

                  <p style={{ textAlign: "center", marginTop: "16px", fontSize: "0.85rem", color: "#555" }}>
                    Or{" "}
                    <span
                      style={{ color: "#1a7fff", fontWeight: "600", cursor: "pointer" }}
                      onClick={handleCreateNew}
                    >
                      Still want to create ABHA address
                    </span>
                  </p>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default PerferredAbhaOptions;